export const EMAIL_DETAILS_FORM_FIELDS_MAP = {
  AccountableRecruiter: {
    key: 'accountableRecruiter'
  },
  Candidate: {
    key: 'candidate'
  },
  HiringAuthority: {
    key: 'hiringAuthority'
  },
  CancelEmailToHiringAuthority: {
    key: 'cancelEmailToHiringAuthority'
  },
  CarbonCopy: {
    key: 'carbonCopy'
  },
  BlindCarbonCopy: {
    key: 'blindCarbonCopy'
  },
  EmailSubject: {
    key: 'emailSubject'
  },
  EmailBody: {
    key: 'emailBody'
  },
  ResolvedEmailBody: {
    key: 'resolvedEmailBody'
  },
  InterviewDate: {
    key: 'interviewDate'
  },
  InterviewTimeFrame: {
    key: 'interviewTimeFrame'
  },
  InterviewFromHour: {
    key: 'interviewFromHour'
  },
  InterviewToHour: {
    key: 'interviewToHour'
  },
  InterviewTimezone: {
    key: 'interviewTimezone'
  }
};
